import React from 'react'
import PropTypes from 'prop-types'
import CategoriesRepository from '../../src/repositories/CategoriesRepository'
import Layout from '../../src/components/layouts'
import NewsRoomPageLayout from '../../src/components/shared/NewsRoomLayout'
import MediaAssetsPage from '../../src/components/pages/MediaAssets'
import { generateSeoData } from '../../src/common/nextSeoUtils'
import { getFullUrlFromReq } from '../../src/common/serverUtils'
import logger from '../../src/common/logger'
import { jsonLdData } from '../../src/common/constants/jsonLd'
import CustomJsonLd from '../../src/components/shared/CustomJsonLd'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'

export async function getServerSideProps({ preview, req }) {
  let data
  try {
    data = await CategoriesRepository.getInstance().getByType(
      'asset',
      undefined,
      preview
    )
  } catch (error) {
    logger.error('MediaAssets page: failed to get serverside props', { error })
  }

  const pagePid = ['media-assets']
  const { canonicalUrl } = getFullUrlFromReq(req, pagePid)
  const seoData = generateSeoData({
    title: 'Media Assets | Freedom Debt Relief',
    description:
      'You are free to use materials such as images, logos, survey results screenshots, and text that are copyrighted by Freedom Debt Relief &#8211; if you give proper attribution.',
    url: canonicalUrl,
  })

  return {
    props: {
      data: data || [],
      seoData,
    },
  }
}

const MediaAssets = ({ data, seoData }) => (
  <Layout footerClassName="max-w-1400" isBrandPage>
    <WithSeoOverrides {...seoData} />
    <CustomJsonLd
      id={'webPage'}
      data={jsonLdData(seoData?.title, seoData?.description, `/media-assets/`)}
    />
    <NewsRoomPageLayout title="Media Assets">
      <MediaAssetsPage data={data} />
    </NewsRoomPageLayout>
  </Layout>
)

MediaAssets.propTypes = {
  data: PropTypes.array.isRequired,
  seoData: PropTypes.object.isRequired,
}

export default MediaAssets
